import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import AppBar from 'material-ui/AppBar';
import {observer} from 'mobx-react';
import FlatButton from 'material-ui/FlatButton';
import AppModel from '../DataModel/AppModel';

export default
@observer class RuiHeader extends Component {

  showNavigation() {
    console.log("showNavigation clicked")
    AppModel.uiSession.showNavigation=true;
  }

  formatUserName() {
    if(!AppModel.userInfo) return (<div></div>);
    if(!AppModel.userInfo.name) return (<div></div>);
    if(AppModel.isImpersonated) {
      return <FlatButton label={"LOGGED IN AS: "+AppModel.userInfo.customer_name +" - "+AppModel.userInfo.name || ""} />
    }
    else
    {
      if(AppModel.uiSession.uiSize=='SMALL') {
        return <FlatButton label={AppModel.userInfo.id || ""} />
      }
      return <FlatButton label={AppModel.userInfo.customer_name +" - "+AppModel.userInfo.name || ""} />
    }
  }

  render() {
    if(AppModel.uiSession.fixedNavigation) {
      // For devices with enough space to show navigation all the time:
      return (
        <AppBar
          title={uiMsg(AppModel.titleId)}
          iconElementRight={this.formatUserName()}
          showMenuIconButton={false}
        />
      )
    }
    else {
      // For Mobile Devices where the navigation is hiding by default :
      return (
        <AppBar
          title={AppModel.title}
          iconElementRight={this.formatUserName()}
          onLeftIconButtonTouchTap={this.showNavigation}
        />
      )
    }

  }
}



/** WEBPACK FOOTER **
 ** ./src/components/RuiHeader.jsx
 **/